import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/soluciones/acreditacion-contratistas/examine")({
  head: () => ({
    meta: [
      { title: "Examine | Acreditación Contratistas | Mine Class" },
      {
        name: "description",
        content:
          "Examine: gestión y agendamiento de exámenes preocupacionales y ocupacionales para minería.",
      },
      { property: "og:title", content: "Examine | Acreditación Contratistas | Mine Class" },
      { property: "og:description", content: "Gestión y agendamiento de exámenes preocupacionales y ocupacionales para la industria minera." },
      { property: "og:url", content: "https://mine-class.com/soluciones/acreditacion-contratistas/examine" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/soluciones/acreditacion-contratistas/examine" }],
  }),
  component: ExamineContent,
});

function ExamineContent() {
  return (
    <article className="space-y-6 text-[var(--color-on-surface-variant)] text-base md:text-lg leading-relaxed">
      <div>
        <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--color-brand-coral)]">
          Exámenes preocupacionales digitales
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-[var(--color-brand-purple)] mt-1">Examine</h2>
      </div>

      <p>
        Solución para la gestión y agendamiento de exámenes preocupacionales y ocupacionales en minería.
        Conecta a empresas contratistas con una red de centros médicos acreditados, permitiendo cotizar,
        agendar, coordinar y recibir resultados de forma digital, rápida y trazable.
      </p>
      <p>
        Las empresas pueden acelerar sus procesos de acreditación, reducir tiempos administrativos y
        asegurar que sus trabajadores estén listos para ingresar a faena sin retrasos.
      </p>

      <h3 className="text-lg font-bold text-[var(--color-brand-purple)] mt-4">
        Características principales
      </h3>
      <ul className="grid md:grid-cols-2 gap-3 text-base">
        {[
          "Agendamiento digital",
          "Resultados en menos de 24 horas",
          "Red de centros acreditados",
          "Cobertura nacional",
          "Trazabilidad del proceso",
          "Soporte comercial",
        ].map((f) => (
          <li key={f} className="flex items-start gap-2">
            <span className="material-symbols-outlined text-[var(--color-brand-coral)] text-base mt-1">
              check_circle
            </span>
            {f}
          </li>
        ))}
      </ul>

      <div className="pt-4">
        <a
          href="https://examine.cl/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-[var(--color-brand-coral)] text-white text-xs font-bold uppercase tracking-widest rounded-full hover:bg-[var(--color-brand-purple)] transition-colors"
        >
          Saber más
          <span className="material-symbols-outlined text-base">arrow_forward</span>
        </a>
      </div>
    </article>
  );
}
